import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './fonts/FuzzyBubbles-Bold.ttf';
import './fonts/FuzzyBubbles-Regular.ttf';
import './fonts/PermanentMarker-Regular.ttf';
import './fonts/MontserratAlternates-Bold.ttf';
import './fonts/MontserratAlternates-Light.ttf';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

